import { wsgSkpApiHeader } from './header'
import { getAccLevelResponse } from './responseHandler'
import { getAccountLevel1Endpoint } from '../firestore/getGdeSkpApiSettings'
import { HTTP_POST } from '../common/appConstants'
import { accountLevel1ReqBody } from './skpApiDataModel'
import { addCache, getCache } from '../firestore/cache'

// One hour cache expiration. This is to validate a customer and apply a cache so we do not need to read its validity from the backend every time.
// If a customer is invalidated by IRM, the max it takes is one hour before the cache will eject it.
const accountLevel1Expires = 60 * 60 * 1000

/**
 * 
 * @param {string} system environment info
 * @param {string} accountLevel1Code accountlevel1code
 * @returns {string} response from accountLevel1
 */
export const validateAndGetAccountLevel1 = async (system, accountLevel1Code) => {
  try {
    const cacheKey = `${system}-${accountLevel1Code}`
    const doc = 'validateAndGetAccountLevel1'
    let accountLevel1Response = getCache(doc, cacheKey)
    if (!accountLevel1Response) {
      const result = await Promise.all([
        wsgSkpApiHeader(),
        getAccountLevel1Endpoint()
      ])
      const headerResponse = result[0]
      const apiUrl = result[1]
      const requestBody = accountLevel1ReqBody(system, accountLevel1Code)
      accountLevel1Response = await getAccLevelResponse(HTTP_POST, apiUrl, requestBody, {}, headerResponse)
      if (accountLevel1Response.success) {
        addCache(doc, cacheKey, accountLevel1Response, accountLevel1Expires)
      }
    }
    return accountLevel1Response    
  } catch (error) {
    if (error?.message) {
      return { error: error.message }
    } else {
      return { error: error?.errors[0]?.message ? error?.errors[0]?.message : 'unexpected error occurred' }
    }
  }
}

